module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-door-vertical-side-mask.bbdd3372.png";